/**
 * dtokgoz 16.10: @servicestack/client JsonServiceClient istekleri (fetch) AuthInterceptor'dan geçmiyor. Bu kanca her isteğin
 * yöntem + adresini ekran hata kaydına "son istek" olarak yazar; böylece servis 200 dönüp gövdesinde hata taşıdığında
 * (ApiResult.error → showError) destek talebine hangi servisin (ör. GenKisi_KpsGuncelle_Request) hata verdiği girer.
 *
 * GÜVENCE: önceden kurulmuş globalRequestFilter varsa aynen çağrılır; isteğe (reqInit) dokunulmaz; kayıt yazımı hiç
 * fırlatmaz. Birden çok kez çağrılsa da bir kez kurulur.
 */
import { JsonServiceClient } from '@servicestack/client';
import { ekranHataKaydi } from './ekran-hata-kaydi';

const KURULDU = '__dkHataKaynagi';

export function ekranHataKaydiServiceStackKur(): void {
  try {
    const onceki: any = JsonServiceClient.globalRequestFilter;
    if (onceki && onceki[KURULDU]) {
      return;
    }
    const filtre: any = (req: any) => {
      ekranHataKaydi.istek(req?.method, req?.url);
      if (onceki) {
        onceki(req);
      }
    };
    filtre[KURULDU] = true;
    JsonServiceClient.globalRequestFilter = filtre;
  } catch {
    // kurulamazsa yalnız servis adı kayda girmez; istekler etkilenmez
  }
}
